export default {
  metaTitle: 'Talking Messages',
  pageTitle: 'Customer Service Chat Management',
  region: 'Region',
  placeholder1: 'customer#',
  column1: 'Customer#',
  column2: 'Talk ID',
  column3: 'Nick',
  column4: 'Create Time',
  column5: 'Last Time',
  column6: 'Last Staffid',
  column7: 'operation',
  chat: 'Chat',
  message: 'Customer Chats'
}
